/*
  Mobile thumbnail strip behaviour. Pairs with
  snippets/product-thumbnails-mobile.liquid.

  The `grid` and `collage` galleries are native scroll-snap containers below
  1068px, so there is no carousel library to talk to - tapping a thumb is a
  scroll, and tracking the active image is an IntersectionObserver.

  Thumbs are `Thumb-<section>-<media>`, slides are `Slide-<section>-<media>`,
  both already emitted by the theme's own snippets. The key is read off the id
  rather than added as a data attribute so `product-thumbnail.liquid` stays
  untouched and shared with the desktop rail.
*/
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function behavior() {
    return REDUCED.matches ? 'auto' : 'smooth';
  }

  function keyOf(el, prefix) {
    var id = el.id || '';
    return id.indexOf(prefix) === 0 ? id.slice(prefix.length) : null;
  }

  function centerWithin(container, child) {
    var cRect = container.getBoundingClientRect(),
      chRect = child.getBoundingClientRect(),
      delta = chRect.left - cRect.left - (cRect.width - chRect.width) / 2;

    container.scrollTo({ left: container.scrollLeft + delta, behavior: behavior() });
  }

  function setup(strip) {
    // The snippet ships its own <script>, so a page with two product sections
    // would run this twice. Bind each strip once.
    if (strip.dataset.thumbsBound === 'true') return;
    strip.dataset.thumbsBound = 'true';

    var wrapper = strip.closest('.thb-product-detail');
    if (!wrapper) return;

    var gallery = wrapper.querySelector('.product-images');
    if (!gallery) return;

    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.product-thumbnail'));
    if (!thumbs.length) return;

    var byKey = {};
    thumbs.forEach(function (thumb) {
      var key = keyOf(thumb, 'Thumb-');
      if (!key) return;
      byKey[key] = thumb;

      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');

      function activate() {
        var slide = wrapper.querySelector('#Slide-' + window.CSS.escape(key));
        if (slide) centerWithin(gallery, slide);
      }

      thumb.addEventListener('click', activate);
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      });
    });

    function mark(key) {
      var thumb = byKey[key];
      if (!thumb || thumb.classList.contains('is-initial-selected')) return;

      thumbs.forEach(function (t) {
        t.classList.remove('is-initial-selected');
      });
      thumb.classList.add('is-initial-selected');
      centerWithin(strip, thumb);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
        });
        if (!best) return;

        var key = keyOf(best.target, 'Slide-');
        if (key) mark(key);
      },
      { root: gallery, threshold: [0.6] }
    );

    wrapper.querySelectorAll('.product-images__slide').forEach(function (slide) {
      observer.observe(slide);
    });
  }

  function init() {
    document.querySelectorAll('.product-thumbnail-container--mobile').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
